export default "__VITE_ASSET__529cfe10__"